export const TermsAndService = [
  {
    id: "acceptance_1",
    title: "1. Acceptance of Terms",
    details: [
      {
        description:
          'Welcome to the Nivaran Foundation ("Nivaran," "we," "us," or "our"). These Terms of Use ("Terms") constitute a legally binding agreement between you ("User," "you," or "your") and the Nivaran Foundation regarding your access to and use of our website(s) (including https://www.nivaranfoundation.org), mobile applications, donation platforms, volunteer portals, social media pages, and any other online services or platforms we operate (collectively, the "Services").',
      },
      {
        description:
          "By accessing, browsing, or using the Services, you acknowledge that you have read, understood, and agree to be bound by these Terms and our Privacy Policy. If you do not agree to these Terms, you must not access or use the Services.",
      },
      {
        description:
          "These Terms apply to all visitors, users, donors, volunteers, partners, and others who access or use the Services.",
      },
    ],
  },
  {
    id: "scope_2",
    title: "2. Scope and Applicability",
    details: [
      {
        description:
          "The Services are provided to support our mission of empowering communities through healthcare, education, and environmental initiatives. These Terms apply to:",
        list: [
          "General Users: Individuals browsing our website for information.",
          "Donors: Individuals or entities making financial contributions.",
          "Volunteers: Individuals applying for or participating in volunteer opportunities.",
          "Partners: Organizations collaborating with us on projects.",
        ],
      },
      {
        description:
          "Specific services or programs may have additional terms and conditions. In the event of a conflict between these Terms and specific program terms, the specific program terms shall control.",
      },
    ],
  },
  {
    id: "user_responsibilities_3",
    title: "3. User Responsibilities and Prohibited Conduct",
    details: [
      {
        description:
          "You agree to use the Services only for lawful purposes and in accordance with these Terms. You are responsible for all of your activity in connection with the Services.",
      },
      {
        description: "You agree NOT to:",
        list: [
          "Use the Services for any illegal purpose or in violation of any local, state, national, or international law.",
          "Harass, threaten, demean, embarrass, or cause distress to any other user, person, or entity.",
          "Interfere with or damage the Services, including, without limitation, through the use of viruses, cancel bots, Trojan horses, harmful code, flood pings, denial-of-service attacks, packet or IP spoofing, forged routing or electronic mail address information, or similar methods or technology.",
          "Attempt to gain unauthorized access to the Services, other user accounts, computer systems, or networks connected to the Services through hacking, password mining, or any other means.",
          "Collect or harvest any personally identifiable information, including account names, from the Services.",
          "Use any robot, spider, scraper, or other automated means to access the Services for any purpose without our express written permission.",
          "Impersonate any person or entity or misrepresent your affiliation with a person or entity.",
          "Engage in any commercial activity (including but not limited to advertising or selling products) on the Services without our prior written consent.",
        ],
      },
    ],
  },
  {
    id: "donations_4",
    title: "4. Donations and Financial Transactions",
    details: [
      {
        description:
          "Donations are processed as described below. You will receive a donation receipt by email for your records.",
        list: [
          "Processing: We use GoDaddy Payments to process donations. By making a donation, you agree to GoDaddy Payments' terms and conditions.",
          "Monthly Donations: When you choose monthly giving and authorize it at checkout, we charge the displayed total today and once each month until you cancel. The total includes any processing contribution you select. Shorter months use the last day when necessary. Use the private link in any monthly donation receipt to cancel before the next scheduled payment, or contact us for assistance. A payment already being processed may still complete.",
          "Refunds: Donations are generally non-refundable. Refund requests for errors will be reviewed on a case-by-case basis if submitted within 7 days of the transaction.",
          "Designated Funds: While we honor donor intent to support specific programs, we reserve the right to reallocate funds to other areas of need if a program is fully funded or cannot be carried out, ensuring your gift still supports our charitable mission.",
        ],
      },
    ],
  },
  {
    id: "intellectual_property_5",
    title: "5. Intellectual Property Rights",
    details: [
      {
        description:
          'The Services and their entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof) are owned by the Nivaran Foundation, its licensors, or other providers of such material and are protected by United States and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.',
      },
      {
        description:
          "Trademarks: The Nivaran Foundation name, logo, and all related names, logos, product and service names, designs, and slogans are trademarks of the Nivaran Foundation. You must not use such marks without our prior written permission.",
      },
      {
        description:
          "License: We grant you a limited, non-exclusive, non-transferable, and revocable license to access and use the Services for your personal, non-commercial use. You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our Services without our prior written consent.",
      },
    ],
  },
  {
    id: "disclaimers_6",
    title: "6. Disclaimers",
    details: [
      {
        description:
          'YOUR USE OF THE SERVICES IS AT YOUR SOLE RISK. THE SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. NIVARAN FOUNDATION EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.',
      },
      {
        description:
          "We do not guarantee that the Services will be uninterrupted, secure, or error-free, or that any defects will be corrected. We make no warranty regarding the accuracy, timeliness, truthfulness, completeness, or reliability of any content obtained through the Services.",
      },
    ],
  },
  {
    id: "limitation_liability_7",
    title: "7. Limitation of Liability",
    details: [
      {
        description:
          "TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL NIVARAN FOUNDATION, ITS AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, OR LICENSORS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM (i) YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE SERVICES; (ii) ANY CONDUCT OR CONTENT OF ANY THIRD PARTY ON THE SERVICES; (iii) ANY CONTENT OBTAINED FROM THE SERVICES; AND (iv) UNAUTHORIZED ACCESS, USE, OR ALTERATION OF YOUR TRANSMISSIONS OR CONTENT, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY, WHETHER OR NOT WE HAVE BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE.",
      },
    ],
  },
  {
    id: "indemnification_8",
    title: "8. Indemnification",
    details: [
      {
        description:
          "You agree to defend, indemnify, and hold harmless the Nivaran Foundation and its licensee and licensors, and their employees, contractors, agents, officers, and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees), resulting from or arising out of a) your use and access of the Service, or b) a breach of these Terms.",
      },
    ],
  },
  {
    id: "termination_9",
    title: "9. Termination",
    details: [
      {
        description:
          "We may terminate or suspend your account and bar access to the Services immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.",
      },
      {
        description:
          "If you wish to terminate your account, you may simply discontinue using the Services. All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity, and limitations of liability.",
      },
    ],
  },
  {
    id: "governing_law_10",
    title: "10. Governing Law and Dispute Resolution",
    details: [
      {
        description:
          "These Terms shall be governed and construed in accordance with the laws of the State of Massachusetts, United States, without regard to its conflict of law provisions.",
      },
      {
        description:
          'Any dispute arising out of or relating to these Terms or the Services shall be resolved through binding arbitration administered by the American Arbitration Association ("AAA") in accordance with its Commercial Arbitration Rules. The arbitration shall be conducted in Boston, Massachusetts. Judgment on the award rendered by the arbitrator(s) may be entered in any court having jurisdiction thereof.',
      },
    ],
  },
  {
    id: "amendments_11",
    title: "11. Amendments to Terms",
    details: [
      {
        description:
          'We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice of any material changes by posting the new Terms on this page and updating the "Effective Date" at the top. Your continued use of the Service after any such changes constitutes your acceptance of the new Terms.',
      },
    ],
  },
  {
    id: "contact_12",
    title: "12. Contact Information",
    details: [
      {
        description:
          "If you have any questions about these Terms, please contact us at:",
      },
      {
        description: "NIVARAN FOUNDATION, INC.",
      },
      {
        description:
          "1025 Massachusetts Ave, Suite 303, Arlington, MA 02476, USA",
      },
      {
        description: "Email: privacy@nivaranfoundation.org",
      },
      {
        description: "Phone: (339) 707-2895",
      },
      {
        description: "EIN: 41-2656587",
      },
    ],
  },
];
